<template>
  <div>
    <NBar title="WiFi配网"/>
    <div class="content">
      <img :src='require("@/resource/img/device/wifi.e68e86a0.jpeg")' class="img">
      <div class="text-div">
        <span>第一步：手机连接2.4G wifi（wifi名称和密码不能带特殊字符）</span>
        <span>第二步：长按识别以上二维码，进入配网页面</span>
        <span>*备注：若配网不成功，尝试重启设备，再重新配置网络。</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Wifi'
}
</script>

<style scoped>
  .content {
    background: #fff;
    text-align: center;
    height: 90vh;
    padding: 30px 20px 0 30px;
  }

  .content .img {
    width: 60%;
  }

  .content .text-div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .content .text-div span{
    height: 25px;
    line-height: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/Wifi.vue